checkInputs();
function checkInputs() {
    var $inputs = $('input[type="text"], input[type="email"], input[type="password"], input[type="tel"], textarea');
    $inputs.each(function () {
        $(this).closest('.form-group').toggleClass('focused', !!$(this).val());
    });

    $inputs.on('click focus', function () {
        $(this).closest('.form-group').addClass('focused');
    });

    $inputs.on('blur', function () {
        $(this).closest('.form-group').toggleClass('focused', !!$(this).val());
    });
    $('#fullName').closest('.form-group').toggleClass('focused', !!$('#fullName').val());
    $('#name').closest('.form-group').toggleClass('focused', !!$('#fullName').val());
}


$(document).on("cbox_complete", function () {
    checkInputs();
});